<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des billets"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/purchase-product-participant/list">
        </DynamicCardList>
    </div>
</template>

<script>
    import DynamicCardList from '../../components/DynamicCardList'
    export default {
        name: 'TicketList',
        components: {
            DynamicCardList
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('# Billet'),
                        key: 'ticketNumber',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de création'),
                        key: 'creationDate',
                        sortable: true,
                        type: 'date'
                    },
                    {
                        label: Core.Definition.getDefinition('Prénom'),
                        key: 'firstname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom de famille'),
                        key: 'lastname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de naissance'),
                        key: 'birthdate',
                        sortable: true,
                        type: 'date'
                    },
                    {
                        label: Core.Definition.getDefinition('Équipe'),
                        key: 'teamId',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Catégorie'),
                        key: 'participantCategory',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('T-Shirt: Taille'),
                        key: 'tshirtSize',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('T-Shirt: Nom personnalisé'),
                        key: 'tshirtCustomName',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Type d\'achat'),
                        key: 'purchaseType',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('ID achat'),
                        key: 'purchaseId',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Produit'),
                        key: 'productTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Prix'),
                        key: 'regularPrice',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: '#'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'firstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'lastname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'teamId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'participantCategoryId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'purchaseType'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'purchaseId'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        },
                        {
                            id: 'title',
                            type: 'text',
                            label: Core.Definition.getDefinition('Titre'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                switch(row.purchaseType) {
                    case Core.Product.typeStandard:
                        this.$router.push('/commerce/commandes/' + row.purchaseId)
                        break
                    case Core.Product.typeRecurringSubscription:
                        this.$router.push('/commerce/abonnements-recurrents/' + row.purchaseId)
                        break
                    case Core.Product.typeLimitedSubscription:
                        this.$router.push('/commerce/abonnements-limites/' + row.purchaseId)
                        break
                }
            }
        }
    }
</script>
